import { serviceNames, diContainer } from '../../service-setup/diContainer';
import { SignInApiSdk } from '../../api/SignInApiSdk';
import { action, computed, observable } from 'mobx';
import { IApiError } from '../domain/entities/IApiError';
import { FAIL_LOGIN_ATTEMPT } from '../constants/constants';

export class SignInRepository {
    private apiSdk: SignInApiSdk;

    @observable private _email: string;
    @observable private _password: string;
    @observable apiError: IApiError | null;

    @observable captchaSuccessToken: string | null;
    @observable isSignInInProgress: boolean = false;

    constructor() {
        this.apiSdk = diContainer.get(serviceNames.signInApiSdk);
    }

    public signIn = async (username: string, password: string) => {
        return this.apiSdk.signIn({
            grant_type: 'password',
            username,
            password
        });
    };

    @computed
    public get email() {
        return this._email;
    }

    @action
    public setEmail(email: string) {
        this._email = email;
    }

    @computed
    public get password() {
        return this._password;
    }

    @action
    public setPassword(password: string) {
        this._password = password;
    }

    @computed
    get isUserWarned() {
        return (
            !!this.apiError &&
            !!this.apiError.errorResponse &&
            !!this.apiError.errorResponse.data &&
            this.apiError.errorResponse.data.detail === FAIL_LOGIN_ATTEMPT.WARNING
        );
    }

    @computed
    get isUserLocked() {
        return (
            !!this.apiError &&
            !!this.apiError.errorResponse &&
            !!this.apiError.errorResponse.data &&
            (this.apiError.errorResponse.data.detail === FAIL_LOGIN_ATTEMPT.FIRST_LOCK ||
                this.apiError.errorResponse.data.detail === FAIL_LOGIN_ATTEMPT.SECOND_LOCK)
        );
    }

    @action
    public updateCaptchaToken = (token: string | null) => {
        this.captchaSuccessToken = token;
    };

    @action
    public resetCaptchaToken() {
        this.captchaSuccessToken = null;
    }

    @action
    public updateSignInProgress(isInProgress: boolean) {
        this.isSignInInProgress = isInProgress;
    }

    @action
    public closeModalError = () => {
        this.apiError = null;
    };

    @action
    public handleCallError = (error: IApiError) => {
        this.updateSignInProgress(false);
        this.resetCaptchaToken();
        this.apiError = error;
        console.error(error.message);
    };

    @action
    public clearStore() {
        this._email = '';
        this._password = '';
    }
}
